import { render } from "./UserSvg.vue?vue&type=template&id=bc59d8e6&bindings={}"
import script from "./UserSvg.vue?vue&type=script&lang=ts"
export * from "./UserSvg.vue?vue&type=script&lang=ts"
script.render = render

export default script